import {
  useSelector as reactReduxUseSelector,
  useStore as reactReduxUseStore,
  useDispatch as reactReduxUseDispatch,
} from 'react-redux';
import { Action, UnknownAction } from 'redux';
import { CashlinkStore, RootAppState } from 'store/types';
import { AppDispatch } from '.';

export function useStore<S extends RootAppState = RootAppState, A extends Action = UnknownAction>() {
  return reactReduxUseStore<S, A>() as CashlinkStore<S, A>;
}

export const useDispatch = () => reactReduxUseDispatch<AppDispatch>();

export function useSelector<TState extends RootAppState = RootAppState, TSelected = unknown>(
  selector: (state: TState) => TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean,
) {
  return reactReduxUseSelector<TState, TSelected>(selector, equalityFn);
}
